import { ReactElement } from 'react'
import styled from 'styled-components'

import {
  IDraggedLocation,
  ILocationRemove,
  IRoutingProjectPlanModel,
  IRoutingProjectPlanOptimization
} from 'features/RoutingProjects/types'
import { RouteItem } from 'features/RoutingProjects/components/RoutingProjectSidebar/OptimizedRoutesList/RouteItem'
import { useSidebarContext } from 'features/RoutingProjects/components/RoutingProjectSidebar'

const RoutesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: fit-content;
`

interface IOptimizedRoutesListProps {
  routingProjectId: string
  draggedLocation: IDraggedLocation | null
  onLocationRemove: (args: ILocationRemove) => void
  planModel: IRoutingProjectPlanModel
  setPlanModel: (planModel: IRoutingProjectPlanModel) => void
  currentOptimization: IRoutingProjectPlanOptimization
}

export const OptimizedRoutesList = ({
  routingProjectId,
  draggedLocation,
  onLocationRemove,
  planModel,
  setPlanModel,
  currentOptimization
}: IOptimizedRoutesListProps): ReactElement => {
  const { overlayDisplayedRouteId } = useSidebarContext()

  return (
    <RoutesList>
      {currentOptimization.routes.map((route, routeIndex) => {
        if (route.id === overlayDisplayedRouteId) {
          return null
        }
        return (
          <RouteItem
            key={route.id}
            routingProjectId={routingProjectId}
            route={route}
            routeIndex={routeIndex}
            draggedLocation={draggedLocation}
            onLocationRemove={onLocationRemove}
            planModel={planModel}
            setPlanModel={setPlanModel}
            currentOptimization={currentOptimization}
          />
        )
      })}
    </RoutesList>
  )
}
